import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import React from 'react';
import Issue from './Issue';
const getExpandedClasses = (blockIndex, rowIndex, expandedIssues) => {
    const hasIndexedProperty = Object.prototype.hasOwnProperty.call(expandedIssues, `${blockIndex}#${rowIndex}`);
    const isExpanded = hasIndexedProperty && expandedIssues[`${blockIndex}#${rowIndex}`].length;
    return clsx('report-detail__code-issues-container', {
        'report-detail__code-issues-container--expanded': isExpanded,
    });
};
export const CodeIssues = (props) => {
    const { blockIndex, rowIndex, startLine, messages, expandedIssues, toggleIssueDocs } = props;
    return _jsx("div", { className: 'report-detail__code-issues', children: _jsx("div", { className: getExpandedClasses(blockIndex, rowIndex, expandedIssues), children: messages[startLine + rowIndex].map((message, key) => (_jsx(Issue, { issue: message, className: 'report-detail__code-issue issue', onIssueExpandClick: () => toggleIssueDocs(blockIndex, rowIndex, key) }, key))) }) });
};
